import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Select, Form, DatePicker, Image, Avatar, Button, Row, Col, message } from 'antd';
import { URL } from '../../../config/api';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { disableSpinner, enableSpinner } from '../../../redux/actions/appActions';
import AuthContext from '../../App/authContext';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const { Option } = Select;

const ModalBody = ({close, handleSubmit, platform, update}) => {
    console.log(platform);
    const [name, setName] = useState('');
    const [form] = Form.useForm();
    // const [defaultDate, setDefaultDate] = useState(moment(new Date()));


    useEffect(() => {
        if(!platform) return;

        setName(platform.Name);

        form.setFieldsValue({
            name: platform.Name,
        })

        // setDefaultDate(moment(new Date(user.DateOfBirth)));
    }, [update])

    const onFinish = (values) => {
        handleSubmit({
            name: name
        })
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <div className="form form--horizontal">
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="name" label="Name"
                            rules={[
                                {
                                    required: true,
                                    message: `Name is required!`,
                                },
                            ]}>
                            <input
                                name="name"
                                type="name"
                                value={name}
                                placeholder="Name"
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
            <Row style={{justifyContent: 'center'}}>
                <Button type="text" onClick={close}>Cancel</Button>
                <Button type="primary" htmlType="submit">{platform ? 'Update' : 'Add'}</Button>
            </Row>
        </Form>
        
    )
}

export default ModalBody;